import { api, headers } from "./api";

const RESOURCE = 'konsultasi';

export const getsKonsultasi = (receiver_id)=> api.get(RESOURCE+'/'+receiver_id, headers);

export const sendKonsultasi = (data)=> api.post(RESOURCE, data, headers);